import { Flex, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

export const PublicRecordInfoSection = ({
  children,
  title,
}: PropsWithChildren<{ title: string }>) => (
  <Flex flexDirection="column" marginTop="1.25rem">
    <Typography variant="h2">{title}</Typography>
    {children}
  </Flex>
);
